import aboutImg from '../assets/aboutus.png';
import Team from '../components/Team';

const About = () => {

    return (
       <section className="mb-12">
            <h1 className="transition transform duration-300 ease-in-out text-center text-4xl text-indigo-700 font-semibold font_poppins hover:scale-105">About us</h1>
            <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-10 my-8">
                <div className="flex flex-col justify-center">
                    <p className="text-gray-500 text-base text-justify">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Fugiat inventore consectetur commodi rem saepe incidunt libero blanditiis modi quaerat cumque illo facere nulla temporibus, nobis mollitia accusantium eveniet? Maiores quisquam iste magni molestias. Cumque vitae voluptate harum quam, doloribus deserunt reiciendis, unde, labore dolor cupiditate odio impedit adipisci libero magni laborum nostrum nobis! Nihil asperiores expedita natus consequuntur non similique architecto, modi corrupti saepe facere ad illo mollitia sapiente optio nostrum distinctio laudantium, voluptatem deleniti aperiam consequatur odio. Asperiores suscipit, earum adipisci illo autem placeat minus neque ad fuga sapiente sunt aperiam eius et nobis quos aliquid ut hic sequi?</p>
                </div>
                <div>
                    <img className="w-full h-96 object-cover" src={aboutImg} alt="about" />
                </div>
            </div>
            <Team />
        </section>
    )
}

export default About
